import { useForm } from "@formspree/react";
import React from "react";
import { toast } from "react-toastify";
import UseTitle from "../../Hooks/UseTitle";

const BookingOnline = () => {
  UseTitle("Online Booking");
  const [state, handleSubmit] = useForm("xknaznrw");

  if (state.succeeded) {
    return toast.success(
      "Thanks for submitting your Request.Our team will be notified as soon as Possible",
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
  }

  return (
    <div className="bookingBg">
      <div className="max-w-screen-xl mx-auto pt-32 ">
        <div
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
          className="nahid-title-designer max-w-screen-xl mx-auto md:px-0 px-5"
        >
          <h1 className="text-[30px] ">Book at Now</h1>
          <p className="my-5 text-[20px]"> Do your booking right now!</p>
          <p className="text-[20px]">Or Call Now: 01867-877-677</p>
        </div>
        <div className="flex items-center justify-center p-12">
          <div className="mx-auto w-full ">
            {/* action="https://formspree.io/f/xknaznrw" method="POST" */}
            <form onSubmit={handleSubmit}>
              <div className="-mx-3 flex flex-wrap">
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="fName"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      First Name
                    </label>
                    <input
                      type="text"
                      name="First Name"
                      id="fName"
                      required
                      placeholder="First Name"
                      className="w-full text-[14px] rounded-md border border-[#f3ecec] bg-white py-3 px-6 font-medium text-[hsl(216,2%,55%)] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="fName"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="Last Name"
                      id="fName"
                      required
                      placeholder="Last Name"
                      className="w-full text-[14px] rounded-md border border-[#f3ecec] bg-white py-3 px-6 font-medium text-[hsl(216,2%,55%)] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
              </div>
              <div className="-mx-3 flex flex-wrap">
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="fName"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Your Email
                    </label>
                    <input
                      type="email"
                      name="Email"
                      id="fName"
                      required
                      placeholder="Your Email"
                      className="w-full text-[14px] rounded-md border border-[#f3ecec] bg-white py-3 px-6 font-medium text-[hsl(216,2%,55%)] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="mNo"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Your Mobile No
                    </label>
                    <input
                      type="tel"
                      name="Mobile"
                      id="mNo"
                      required
                      placeholder="Your Mobile No"
                      className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
              </div>

              <div className="-mx-3 flex flex-wrap">
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="date"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Check in Date:
                    </label>
                    <input
                      type="date"
                      name="Check in Date"
                      id="date"
                      required
                      className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="date"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Check out Date:
                    </label>
                    <input
                      type="date"
                      name="Check Out Date"
                      id="date"
                      required
                      className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
              </div>
              <div className="-mx-3 flex flex-wrap">
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="guest"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Rooms
                    </label>
                    <input
                      type="number"
                      name="Guest"
                      id="guest"
                      required
                      placeholder="5"
                      min="0"
                      className="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
                <div className="w-full px-3 sm:w-1/2">
                  {/* <div className="mb-5">
                                    <label
                                        for="time"
                                        className="mb-3 block text-[20px] font-medium text-[#07074D]"
                                    >
                                        Time
                                    </label>
                                    <input
                                        type="time"
                                        name="time"
                                        id="time"
                                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                    />
                                </div> */}
                  <label
                    for="small"
                    className="mb-3 block text-[20px] font-medium text-[#07074D]"
                  >
                    Room Category
                  </label>
                  <select
                    id="small"
                    required
                    name="Room Category"
                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                  >
                    <option selected>Choose room</option>
                    <option value="Deluxe">Deluxe</option>
                    <option value="Premium">Premium</option>
                  </select>
                  {/* <div className="mb-5">
                                    <label
                                        for="time"
                                        className="mb-3 block text-[20px] font-medium text-[#07074D]"
                                    >
                                        Time
                                    </label>
                                    <input
                                        type="time"
                                        name="time"
                                        id="time"
                                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                    />
                                </div> */}
                </div>
              </div>
              <div className="-mx-3 flex flex-wrap">
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="guest"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Adults
                    </label>
                    <input
                      type="number"
                      name="Adults"
                      id="guest"
                      required
                      placeholder="5"
                      min="0"
                      className="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
                <div className="w-full px-3 sm:w-1/2">
                  <div className="mb-5">
                    <label
                      for="guest"
                      className="mb-3 block text-[20px] font-medium text-[#07074D]"
                    >
                      Children
                    </label>
                    <input
                      type="number"
                      name="Children"
                      id="guest"
                      required
                      placeholder="5"
                      min="0"
                      className="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                    />
                  </div>
                </div>
              </div>
              <div className="mb-5">
                <div className="mb-5">
                  <label
                    for="time"
                    className="mb-3 block text-[20px] font-medium text-[#07074D]"
                  >
                    Arrival Time
                  </label>
                  <input
                    type="time"
                    name="Arrival Time"
                    id="time"
                    required
                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-[14px] font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="hover:shadow-form bg-[#bb4f32] py-3 px-8 text-center text-[20px] font-semibold text-white outline-none"
                >
                  Booking
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingOnline;
